.fixedTableHeadFoot {
  overflow-y: auto;
  > table > thead,
  > table > tfoot {
    position: sticky;
  }
  > table > thead {
    inset-block-start: 0; /* "top" */
  }
  > table > tfoot {
    inset-block-end: 0; /* "bottom" */
    z-index: 1; /* above the body rows that scroll under it */
  }
}
